( function( $ ) {
	function hideScroll( $section ) {
		setTimeout( ()=>{
			const scrollX = $section.find( '.scroll-x' );
			const scrollTrackWidth = scrollX.find( '.scroll-element_track' ).width();
			const scrollBarWidth = scrollX.find( '.scroll-bar' ).width();

			$( scrollX ).removeClass( 'hide' );

			if ( scrollTrackWidth === scrollBarWidth ) {
				scrollX.addClass( 'hide' );
			}
		},1000 );
	}

	let initBlock = function( section = false, isAdmin = false ) {
		const $section = section ? $( section ) : $( '.section-our-process' );

		$section.each( function() {
			window.app.main.customScrollbarsForSection( this );
			const $sectionInstance = $( this );

			if ( $sectionInstance.hasClass( 'section-our-process--style-v1' ) ) {
				// calculate one block height
				$sectionInstance.find( '.js-one-process' ).each( function() {
					const target = $( this );

					target.show();

					const height = target.height();

					target.attr( 'data-height', height );

					if ( target.hasClass( 'active' ) )
					{$sectionInstance.find( '.js-our-process__content' ).height( height );}
					else {
						target.hide();
					}
				} );

				if ( isAdmin ) {return;}

				//add id for tab item
				$sectionInstance.find( '.js-our-process__item' ).each( ( index, item ) => {
					$( item ).attr( 'id', `js-one-process-${index}` );
				} );

				//Smooth scrolling to element our process
				const smoothScrollToActiveProcess = ( item ) => {
					const processItem = $( item );
					const processItemId = processItem.attr( 'id' );

					if ( processItemId ) {
						$( `#${processItemId}` )[0].scrollIntoView( {block: 'nearest', inline: 'center',  behavior: 'smooth'} );
					}
				};

				// Select click event
				const targetEvents = $._data( $sectionInstance.find( '.js-our-process__item[data-index]' )[0], 'events' );
				const clickEvents = targetEvents ? targetEvents.click : false;

				if ( !clickEvents && $sectionInstance.length ) {
					let activeTab = -1;
					let animationFinished = true;

					$sectionInstance.find( '.js-our-process__item[data-index]' ).on( 'click keydown', activeOutProcess );

					function activeOutProcess( {type, code} ) {
						const animationDuration = 200;
						const index = $( this ).attr( 'data-index' );
						const newHeight = $sectionInstance.find( `.js-one-process[data-index=${index}]` ).attr( 'data-height' );
						const currentIndex = $sectionInstance.find( '.js-one-process.active' ).attr( 'data-index' );

						if ( type === 'keydown' ) {
							if ( !$( this ).is( ':focus' ) || code !== 'Enter' ) {return;}
						}
						if ( index === currentIndex || activeTab === index ) {return;}
						if ( !animationFinished ) {return;}

						activeTab = index;

						$sectionInstance.find( '.js-our-process__item.active' ).removeClass( 'active' );
						$( this ).addClass( 'active' );

						$sectionInstance.find( '.js-one-process.active' ).fadeOut( animationDuration, function() {
							animationFinished = false;
							$( this ).removeClass( 'active' );

							$sectionInstance.find( '.js-our-process__content' ).animate( { height: newHeight }, animationDuration, 'swing', function() {
								$sectionInstance.find( `.js-one-process[data-index=${index}]` ).fadeIn( animationDuration, function() {
									$( this ).addClass( 'active' );
									animationFinished = true;
								} );
							} );
						} );

						smoothScrollToActiveProcess( $( this ) );
					}
				}

				hideScroll( $sectionInstance );
			}
		} );
	};

	window.app.loadBlock( initBlock, 'section-our-process', '.section-our-process' );
} )( jQuery );